import  React from 'react';
import HandleIcon from 'components/HandleIcon';
import { CaretDownFill, Next, Previous } from 'grommet-icons';

const buttonStyle = {
  border: {
    color: 'rgba(0, 0, 0, 0.1)',
    size: '1px',
    style: 'solid',
    radius: '4px',
  },
  pad: {
    vertical: '1px',
    horizontal: '7px',
  },
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const themeConfig: any = {
  global: {
    colors: {
      'primary-color': '#AA81F3',
      'secondary-color': '#3DCAD4',
      'tertiary-color': '#009CFF',
      'accent-color': '#F8C210',
      'light-gray-color': '#F5F7FA',
      'medium-gray-color': '#939393',
      'gray-color': '#5C6D82',
      'dark-gray-color': '#3A4554',
      'dark-color': '#2b3238',
      'medium-color': '#2f373d',
      'black-color': '#000000',
      'dark-border-color': '#22282d',
      'error-color': '#ff5a4d',
      'success-color': '#83d238',
    },
  },
  button: {
    primary: {
      color: 'tertiary-color',
    },
    secondary: {
      color: 'medium-color',
    },
    padding: {
      vertical: '4px',
      horizontal: '4px',
    },
    size: {
      small: buttonStyle,
      medium: buttonStyle,
      large: buttonStyle,
    },
    ...buttonStyle,
  },
  textInput: {
    placeholder: {
      extend: {
        'font-size': '12px',
      },
    },
    extend: {
      height: '28px',
      'font-size': '12px',
      'font-weight': 'normal',
      'font-stretch': 'normal',
      'font-style': 'normal',
      'line-height': 'normal',
      border: 'solid 1px #dddede',
      'border-radius': '5px',
    },
  },
  tab: {
    active: {
      color: 'white',
    },
    border: {
      color: 'medium-gray-color',
      active: {
        color: 'white',
      },
    },
    color: 'medium-gray-color',
  },
  focus: {
    outline: {
      color: 'none',
    },
    shadow: {
      color: 'gray-color',
    },
  },
  text: {
    xsmall: {
      size: '11px',
    },
    small: {
      size: '12px',
    },
    medium: {
      size: '13px',
    },
    large: {
      size: '16px',
    },
  },
  paragraph: {
    xsmall: {
      size: '11px',
    },
    small: {
      size: '12px',
    },
    medium: {
      size: '13px',
    },
    large: {
      size: '15px',
    },
  },
  pagination: {
    button: {
      size: {
        small: {
          pad: {
            vertical: '1px',
            horizontal: '1px',
          },
          font: '12px',
          height: '22px',
          width: '20px',
        },
      },
    },
    icons: {
      next: () => <Next size="18px" />,
      previous: () => <Previous size="18px" />,
    },
  },
  select: {
    icons: {
      down: <CaretDownFill color="black-color" size="small" />,
    },
    container: {
      extend: ` 
        border: solid 1px #dddede;
        background-color: white;
        color: black;
        margin: 0px 0px;
    `,
    },
    clear: {
      container: {
        extend: {
          border: 'solid 1px #dddede',
          'border-radius': '5px',
        },
      },
    },
  },
  checkBox: {
    size: '12px',
    border: {
      width: '1px',
    },
    color: 'light-gray-color',
  },
  rangeSelector: {
    edge: {
      type: <HandleIcon />,
    },
  },
  calendar: {
    day: {
      extend: ({ isSelected }: { isSelected: boolean }) => `
        border-radius: 150px;
        background-color: ${isSelected ? '#009CFF' : undefined}`,
    },
  },
};

export default themeConfig;
